// extracted by mini-css-extract-plugin
module.exports = {"errorBoundary":"q9uqc","title":"_3goMe","text":"_3yORu","details":"_1uTrK","image":"_3EYgW","heading":"_2LmlK"};